import type { ILanguageResources, ITranslationModule } from '../../interfaces';
import { interpolate } from '../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.quotes.QuoteItemCommentModal.';
  public static readonly commentTitle = `${Id.prefix}commentTitle`;
  public static readonly updateButton = `${Id.prefix}updateButton`;
  public static readonly closeButton = `${Id.prefix}closeButton`;
  public static readonly copyToManufacturer = `${Id.prefix}copyToManufacturer`;
  public static readonly copyToClient = `${Id.prefix}copyToClient`;
  public static readonly copyToManufacturerHelper = `${Id.prefix}copyToManufacturerHelper`;
  public static readonly copyToClientHelper = `${Id.prefix}copyToClientHelper`;
  public static readonly confirmCopyToManufacturerTitle = `${Id.prefix}confirmCopyToManufacturerTitle`;
  public static readonly confirmCopyToManufacturerMessage = `${Id.prefix}confirmCopyToManufacturerMessage`;
  public static readonly confirmCopyToClientTitle = `${Id.prefix}confirmCopyToClientTitle`;
  public static readonly confirmCopyToClientMessage = `${Id.prefix}confirmCopyToClientMessage`;
}

export class LangQuoteItemCommentModal {
  private constructor() {}
  public static commentTitle(): string {
    return interpolate(Id.commentTitle);
  }
  public static updateButton(): string {
    return interpolate(Id.updateButton);
  }
  public static closeButton(): string {
    return interpolate(Id.closeButton);
  }
  public static copyToManufacturer(): string {
    return interpolate(Id.copyToManufacturer);
  }
  public static copyToClient(): string {
    return interpolate(Id.copyToClient);
  }
  public static copyToManufacturerHelper(): string {
    return interpolate(Id.copyToManufacturerHelper);
  }
  public static copyToClientHelper(): string {
    return interpolate(Id.copyToClientHelper);
  }
  public static confirmCopyToManufacturerTitle(): string {
    return interpolate(Id.confirmCopyToManufacturerTitle);
  }
  public static confirmCopyToManufacturerMessage(): string {
    return interpolate(Id.confirmCopyToManufacturerMessage);
  }
  public static confirmCopyToClientTitle(): string {
    return interpolate(Id.confirmCopyToClientTitle);
  }
  public static confirmCopyToClientMessage(): string {
    return interpolate(Id.confirmCopyToClientMessage);
  }
}

export class QuoteItemCommentModalModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.commentTitle, 'Comment', 'Title for the comment modal');
    register.add(Id.updateButton, 'Update', 'Button text for update');
    register.add(Id.closeButton, 'Close', 'Button text for close');
    register.add(
      Id.copyToManufacturer,
      'Copy this note to Manufacturer',
      'Checkbox label to copy client notes to manufacturer notes'
    );
    register.add(
      Id.copyToClient,
      'Copy this note to Client',
      'Checkbox label to copy manufacturer notes to client notes'
    );
    register.add(
      Id.copyToManufacturerHelper,
      'Check this to share the same note with the Manufacturer. Please note: this will replace any note the Manufacturer currently has.',
      'Helper text explaining the copy to manufacturer behavior'
    );
    register.add(
      Id.copyToClientHelper,
      'Check this to share the same note with the Client. Please note: this will replace any note the Client currently has.',
      'Helper text explaining the copy to client behavior'
    );
    register.add(
      Id.confirmCopyToManufacturerTitle,
      'Copy note to Manufacturer?',
      'Confirmation dialog title when copying to manufacturer notes'
    );
    register.add(
      Id.confirmCopyToManufacturerMessage,
      'This will replace the Manufacturer’s current note with this one. Are you sure you want to continue?',
      'Confirmation dialog message when copying to manufacturer notes'
    );
    register.add(
      Id.confirmCopyToClientTitle,
      'Copy note to Client?',
      'Confirmation dialog title when copying to client notes'
    );
    register.add(
      Id.confirmCopyToClientMessage,
      'This will replace the Client’s current note with this one. Are you sure you want to continue?',
      'Confirmation dialog message when copying to client notes'
    );
  }
}
